// @flow
import { useParams } from 'react-router-dom';
import { getIn, useFormikContext } from 'formik';
import React, { useContext } from 'react';
import {
  CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME,
  RATE_CARD_BACKEND_NAME,
} from '@src/constants';
import { toastError } from '@presentational/notifications/utils';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { SPMLDMutationsContext } from '@streaming-projects/orgs/org-top-level/sp-custom-discounts/contexts/SPMLDMutationsContext';
import { UpdateFormButton } from '@presentational/buttons/UpdateFormButton';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';

const getIfGlobalDiscountShouldBeDisabled = (readOnlyMode, formik) => {
  //  if we are in RO Mode, return true to disable it unconditionally
  if (readOnlyMode) {
    return true;
  }
  // payload is going to change
  const currentValue = getIn(formik.values, CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME);

  // if the field has not been set yet, return true to disable it
  if (currentValue == null) {
    return true;
  }

  const initialValue = getIn(formik.initialValues, CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME);
  const isTheValueUnChanged = Number(currentValue) === Number(initialValue);

  // if the field has not been touched yet, return true to disable it
  if (isTheValueUnChanged) {
    return true;
  }

  // if the formik form is invalid, return true to disable it
  return !formik.isValid;
};

const handleGlobalDiscountUpdate = async (
  formik,
  orgId,
  commitId,
  orgData,
  commitData,
  updateGlobalDiscount
) => {
  const globalDiscount = getIn(formik.values, CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_BACKEND_NAME);
  const rateCardVersion = orgData?.org[RATE_CARD_BACKEND_NAME];
  const payload = {
    global_discount: globalDiscount,
    version: commitData?.version,
    rate_card_version: rateCardVersion,
  };

  const { error } = await updateGlobalDiscount({
    orgId,
    commitId,
    payload,
  });

  if (error) {
    toastError(
      error,
      'There was an error in updating the discount, please contact #cloud-commitment-estimator channel!'
    );
  } else {
    // otherwise, reload the entire page
    window.location.reload();
  }
};

export const CommitGlobalDiscountsUpdateButtonContainer = ({ readOnlyMode, disabled = false }) => {
  const { orgId, commitId } = useParams();
  const formik = useFormikContext();
  const orgData = useContext(SPOrgContext);
  const commitData = useContext(SPUserCommitDetailsContext);
  const {
    globalDiscountUpdateMutation: [updateGlobalDiscount],
  } = useContext(SPMLDMutationsContext);

  return (
    <UpdateFormButton
      disabled={disabled || getIfGlobalDiscountShouldBeDisabled(readOnlyMode, formik)}
      onClick={() =>
        handleGlobalDiscountUpdate(
          formik,
          orgId,
          commitId,
          orgData,
          commitData,
          updateGlobalDiscount
        )
      }
    />
  );
};
